import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Box, Grid } from '@mui/material';
import { ItemText, setColorStyle, SubtitleItemText } from './BiasInfo';
import {
	money,
	whichDivison,
	whichPriority,
	whichStatus,
	whichTypeOfPacking,
} from '../../../helpers/utils';
import { formatDateMX, formatDateTimeMX } from '../../../helpers/hours';
import { LinearWithValueLabel } from '../../orders/ProgressBar';
import { SearchAppBar } from './BiasInfoAppBar';
import { getOrderInfo } from '../../../actions/orders';
import { useState, useEffect } from 'react';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export const OrderInfo = ({ open, handleClose, orderId = null }) => {
	// Order
	const [order, setOrder] = useState(null);

	useEffect(() => {
		getOrderInfo(orderId).then(({ data }) => {
			setOrder(data);
		});
	}, []);

	return (
		<div>
			{order && (
				<Dialog
					fullScreen
					open={open}
					onClose={handleClose}
					TransitionComponent={Transition}
				>
					{/* Content */}
					<Box sx={{ flexGrow: 1 }}>
						<SearchAppBar
							title={`No. de pedido: ${order?.number_order}`}
							handleClose={handleClose}
						/>
						<div style={{ padding: '20px' }}>
							{/* Information */}
							<SubtitleItemText title='General' first />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={4}>
									<ItemText
										subtitle='No. de pedido'
										text={order?.number_order}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Tipo de empaque'
										text={whichTypeOfPacking(
											order?.type_of_packing
										)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Tipo'
										text={
											order?.type === 'ORD'
												? 'Orden'
												: 'Cotización'
										}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Importe'
										text={money(order?.amount)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='División'
										text={whichDivison(order?.division)}
									/>
								</Grid>
							</Grid>

							{/* Dates */}
							<SubtitleItemText title='Fechas' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={4}>
									<ItemText
										subtitle='Fecha de entrada'
										text={formatDateMX(order?.entry_date)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Fecha de entrega'
										text={formatDateMX(
											order?.delivery_date
										)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Fecha estimada'
										text={formatDateMX(
											order?.delivery_forecast
										)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Fecha de validación'
										text={formatDateMX(
											order?.validation_date
										)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Fecha de autorización'
										text={formatDateMX(
											order?.authorization_date
										)}
									/>
								</Grid>
							</Grid>

							{/* Details */}
							<SubtitleItemText title='Transporte' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={6}>
									<ItemText
										subtitle='Transporte'
										text={order?.transport}
									/>
								</Grid>
								<Grid item xs={6}>
									<ItemText
										subtitle='Consignado a'
										text={order?.consigned_to}
									/>
								</Grid>
							</Grid>

							{/* Status */}
							<SubtitleItemText title='Avances' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={4}>
									<ItemText
										subtitle='Prioridad'
										text={whichPriority(order?.priority)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Estatus'
										text={whichStatus(order?.status)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText subtitle='Progreso' text='' />
									<div
										style={{
											margin: '0 0 10px 0',
											width: '80%',
										}}
									>
										<LinearWithValueLabel
											progress={order?.progress}
										/>
									</div>
								</Grid>
							</Grid>

							{/* Client */}
							<SubtitleItemText title='Cliente' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={3}>
									<ItemText
										subtitle='Razón social'
										text={order?.client_id?.company_name}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='División'
										text={order?.client_id?.division}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Asesor'
										text={order?.client_id?.consultant}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='RFC'
										text={order?.client_id?.rfc}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Banco'
										text={order?.client_id?.bank}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Estado'
										text={order?.client_id?.state}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Municipio'
										text={order?.client_id?.municipality}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Ciudad'
										text={order?.client_id?.city}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Colonia'
										text={order?.client_id?.neighborhood}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Código postal'
										text={order?.client_id?.zip_code}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Número exterior'
										text={order?.client_id?.outside_number}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Número interior'
										text={order?.client_id?.interior_number}
									/>
								</Grid>
							</Grid>

							{/* Shipping */}
							<SubtitleItemText title='Datos de embarque' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={3}>
									<ItemText
										subtitle='Domicilio de embarque'
										text={
											order?.client_id?.address_shipping
										}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Municipio de embarque'
										text={
											order?.client_id
												?.municipality_shipping
										}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Colonia de embarque'
										text={order?.client_id?.colony_shipping}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Código postal de embarque'
										text={
											order?.client_id?.zip_code_shipping
										}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Días de entrega'
										text={
											order?.client_id
												?.delivery_days_shipping
										}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Horario'
										text={order?.client_id?.hours_shipping}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Quién recibe'
										text={
											order?.client_id
												?.who_receives_shipping
										}
									/>
								</Grid>
								<Grid item xs={3}>
									<ItemText
										subtitle='Teléfono de embarque'
										text={order?.client_id?.phone_shipping}
									/>
								</Grid>
							</Grid>

							{/* Created by */}
							<SubtitleItemText title='Creado por' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={4}>
									<ItemText
										subtitle='Nombre'
										text={`${order?.created_by?.first_name} ${order?.created_by?.last_name}`}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Correo'
										text={order?.created_by?.email}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Área'
										text={
											order?.created_by?.area?.name ||
											'No aplica'
										}
									/>
								</Grid>
							</Grid>

							{/* Record */}
							<SubtitleItemText title='Historial' />
							<Grid
								container
								style={{
									...setColorStyle('black'),
									padding: '20px 20px 0 20px',
								}}
							>
								<Grid item xs={4}>
									<ItemText
										subtitle='Creado'
										text={formatDateTimeMX(
											order?.created_at
										)}
									/>
								</Grid>
								<Grid item xs={4}>
									<ItemText
										subtitle='Editado'
										text={formatDateTimeMX(
											order?.updated_at
										)}
									/>
								</Grid>
							</Grid>
						</div>
					</Box>
				</Dialog>
			)}
		</div>
	);
};
